module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-info_monochrome-841a956b.svg";